import React from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { safeFormatDate, formatDateWithLocale } from '../../shared/utils';
import { getActivityIcon } from '../../shared/activityUtils';

const MinimizedDayShare = ({ 
  day, 
  dayIndex,
  continueAccoms,
  isTemplate
}) => {
  const { t } = useTranslation();

  return (
    <Card
      id={`day-card-${day.id}`}
      className={`mb-2 shadow-sm minimized-day`}
    >
      <Card.Header className="bg-light py-2">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="mb-0">
            <i className="bi bi-calendar-date me-1"></i>
            {t('planDetailShare.dayLabel', { number: dayIndex + 1 })}{isTemplate ? '' : `: ${day.date ? formatDateWithLocale(day.date, 'EEE, MMM d') : ''}`}
          </h6>
        </div>
      </Card.Header>
      
      <ListGroup variant="flush">
        {day.summaryTitle?.trim() && (
          <ListGroup.Item className="py-2 px-3">
            <div className="fw-semibold small text-muted">{day.summaryTitle.trim()}</div>
          </ListGroup.Item>
        )}
        {/* Display continuing accommodations at the top */}
        {continueAccoms && continueAccoms.length > 0 && (
          continueAccoms.map((accom, idx) => (
            <ListGroup.Item 
              key={`continued-${idx}`}
              className="py-2 px-3 border-success"
            >
              <div className="d-flex align-items-center">
                <i className="bi bi-house-door me-2 text-success"></i>
                <span className="text-truncate" title={`${t('planDetailShare.stayingAt')}: ${accom.name}`}>
                  <strong>{t('planDetailShare.stayingAt')}:</strong> {accom.name}
                </span>
              </div>
            </ListGroup.Item>
          ))
        )}

        {day.activities && day.activities.length > 0 ? (
          day.activities.map((activity) => (
            <ListGroup.Item 
              key={activity.id}
              className="py-2 px-3"
            >
              <div className="d-flex align-items-center">
                {getActivityIcon(activity) === 'route-icon' ? (
                  <span className="route-icon me-2"></span>
                ) : (
                  <i className={`bi ${getActivityIcon(activity)} me-2`}></i>
                )}
                <span className="text-truncate" title={activity.name}>
                  {activity.name}
                </span>
                {activity.startDateTime && (
                  <small className="text-muted ms-auto minimized-activity-time">
                    {safeFormatDate(activity.startDateTime, 'time')}
                  </small>
                )}
              </div>
            </ListGroup.Item>
          ))
        ) : !day.summaryTitle?.trim() ? (
          <ListGroup.Item className="text-center text-muted py-2">
            {t('planDetailShare.noActivitiesPlanned')}
          </ListGroup.Item>
        ) : null}
      </ListGroup>
    </Card>
  );
};

export default MinimizedDayShare;
